import { stringToDate } from './stringToDate';
export const toTimeFormat = (date) => {
    if (!isNaN(date) && date instanceof Date)
        return date;
    return null;
};
toTimeFormat.hhmm = (date) => format24(date);
toTimeFormat.hhmmxm = (date) => formatAMPM(date);
const format24 = (date) => {
    if (typeof date === 'undefined' || date === '' || date === null) {
        return null;
    }
    let d;
    typeof date === 'string' ? (d = stringToDate(date)) : (d = date);
    if (!d)
        return null;
    let hours = d.getHours();
    let minutes = d.getMinutes();
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${minutes}`;
};
const formatAMPM = (date) => {
    if (typeof date === 'undefined' || date === '' || date === null) {
        return null;
    }
    let d;
    typeof date === 'string' ? (d = stringToDate(date)) : (d = date);
    if (!d)
        return null;
    let hours = d.getHours();
    let minutes = d.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // hour '0' → '12'
    hours = hours < 10 ? `0${hours}` : hours;
    minutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${hours}:${minutes} ${ampm}`;
};
//# sourceMappingURL=toTimeFormat.js.map